import React from 'react';

import { URL_REGEX } from 'constants/url';
import { Link } from 'modules/chat/types/Message';
import { MSG_TAG_REGEX } from 'modules/chat/utils';

const formatLink = (displayText: string, targetUrl: string) => <a href={targetUrl} target="_blank" rel="noreferrer">{displayText}</a>;

const GLOBAL_DETECTION_REGEX = new RegExp([MSG_TAG_REGEX.source, URL_REGEX.source].join('|'), 'gi');

interface MessageTextProps {
  links?: Array<Link>;
  content: string;
  className?: string;
}

const MessageText = ({ links = [], content, className }: MessageTextProps) => {
  const segments = React.useMemo(() => {
    if (!content) { return []; }

    const parts = [];
    let lastIndex = 0;
    for (const match of Array.from(content.matchAll(GLOBAL_DETECTION_REGEX))) {
      const { index } = match;
      if (index > lastIndex) {
        parts.push(content.slice(lastIndex, index));
      }
      parts.push(match[0]);
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < content.length) {
      parts.push(content.slice(lastIndex));
    }

    const remainingLinks = [...links];

    return parts.map(part => {
      if (MSG_TAG_REGEX.test(part)) {
        const linkIndex = remainingLinks.findIndex(l => l.tag === part);
        if (linkIndex !== -1) {
          const link = remainingLinks[linkIndex];
          remainingLinks.splice(linkIndex, 1);
          return formatLink(link.displayText, link.targetUrl);
        }
      } else if (URL_REGEX.test(part)) {
        return formatLink(part, part);
      }

      return part;
    });
  }, [content, links]);

  return (
    <p className={className}>
      {segments.map((segment, index) => (
        <React.Fragment key={index}>
          {segment}
        </React.Fragment>
      ))}
    </p>
  );
};

export default MessageText;
